/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-16 11:13:35
 */ 
export const specimenCn = {
    xunjiadang:'样品管理',
    zhengshuzhuantai:'样品状态',
    qingxuanzhe:'请选择样品状态',
    kehujigei:'客户寄给平台',
    pingtaiyishoudao:'平台已收到',
    pingtaijihui:'平台寄回给客户',
    kehushoudao:'客户收到寄回样品',
    xiaohui:'销毁',
    kaishishijian:'开始时间',
    jieshushijian:'结束时间',
    sousuo:'搜索',
    dingdangbianhao:'订单编号',
    xuhao:'序号',
    yangpingmingcheng:'样品名称',
    yangpingshuliang:'样品数量',
    dingdangbianhao:'订单编号',
    wuliouleixing:'物流类型',
    wulioudanghao:'物流单号',
    jisongleixing:'寄送类型',
    yangpingzuantai:'样品状态',
    chuangjianshijian:'创建时间',
    caozuo:'操作',
    pingtaijigeikehu:'平台寄给客户',
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/specimen/specimenCn.js